import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'irisTransform',
})
export class IrisTransformPipe implements PipeTransform {
  transform<T, R>(value: T, transformFn: (value: T, ...args: unknown[]) => R, ...args: unknown[]): R {
    return transformFn ? transformFn(value, ...args) : null;
  }
}
